import { render, staticRenderFns } from "./AlarmPoint.vue?vue&type=template&id=2180961f&scoped=true"
import script from "./AlarmPoint.vue?vue&type=script&lang=ts"
export * from "./AlarmPoint.vue?vue&type=script&lang=ts"
import style0 from "./AlarmPoint.vue?vue&type=style&index=0&id=2180961f&prod&scoped=true&lang=scss"
import style1 from "./AlarmPoint.vue?vue&type=style&index=1&id=2180961f&prod&lang=scss"
import style2 from "./AlarmPoint.vue?vue&type=style&index=2&id=2180961f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180961f",
  null
  
)

export default component.exports